/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { SET_INPUT_DEVICE } from "constants/ActionTypes";
import { DeviceAction } from "types/Actions";

export type DeviceId = string;

export interface DeviceSettings {
  inputDeviceId: DeviceId;
}

export default function DeviceSettingsReducer(
  deviceSettings: DeviceSettings,
  action: DeviceAction
): DeviceSettings {
  switch (action.type) {
    case SET_INPUT_DEVICE:
      return {
        ...deviceSettings,
        inputDeviceId: action.deviceId,
      };
    default:
      return deviceSettings;
  }
}
